/** Where "Preview your public page" opens (design 24, T28): under the Author profile, which is `/apply`. */
export const PROFILE_PREVIEW_PATH = '/apply/preview';
